// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__2BP_o","storybook":"Icon_storybook__3h1ST"};